// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconPaginationRight: React.FC = () => {
    return (
        <svg
            width="22px"
            height="14px"
            viewBox="0 0 22 14"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="Interactive-Elements/Selector/Pagination-Arrows/UI-:-Pagination-:-Arrow-:-Right"
                    fill="currentColor"
                    fillRule="nonzero"
                >
                    <path d="M13.126241,12.6837632 L13.126241,9.00496031 L0.52263776,9.00496031 C0.233932148,9.00496031 -0.00018318884,8.77214314 -0.00018318884,8.48503839 L-0.00018318884,5.47116721 C-0.00018318884,5.18406246 0.233932148,4.95124528 0.52263776,4.95124528 L13.1273401,4.95124528 L13.1273401,1.36134288 C13.1273401,0.984973325 13.2665637,0.611154196 13.5453771,0.357204945 C14.0835859,-0.132840599 14.8687332,-0.104057254 15.3637095,0.352832791 L21.5749103,6.08326871 C22.1416966,6.60683409 22.1416966,7.49875342 21.5749103,8.0223188 L15.3637095,13.7527547 C14.9779138,14.0118048 14.4129594,14.1054418 13.9253107,13.8463917 C13.4402267,13.636164 13.126241,13.1603279 13.126241,12.6837632 Z"></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconPaginationRight);
